import React, { useState, useEffect } from "react";
import ReactBeforeSlider from "../ReactBeforeSlider/ReactBeforeSlider";

const Modal = ({ image, closeModal, showPreviousImage, showNextImage }) => {
  const [currentImage, setCurrentImage] = useState(image || {});

  // Sync `currentImage` with `image` prop whenever it changes
  useEffect(() => {
    setCurrentImage(image || {});
  }, [image]);

  if (!image) return null;

  // Combine main image with thumbnails if thumbnails exist
  const getThumbnailList = () => {
    const thumbnails = Array.isArray(image.thumbnail) ? image.thumbnail : [];
    return thumbnails.length > 0 ? [image.src, ...thumbnails] : [];
  };

  const handleThumbnailClick = (thumbnail) => {
    if (thumbnail === image.src) {
      // Restore main image properties (before, after)
      setCurrentImage(image);
    } else {
      // Handle other thumbnails
      setCurrentImage({
        ...currentImage,
        src: thumbnail,
        before: null,
        after: null,
      });
    }
  };

  const thumbnails = getThumbnailList();

  return (
    <div className="modal">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={closeModal}>
          &times;
        </button>
        <button className="modal-prev" onClick={showPreviousImage}>
          &lt;
        </button>

        {/* Render the Before-After slider or single image */}
        {currentImage.before && currentImage.after ? (
          <ReactBeforeSlider
            firstImage={{
              imageUrl: currentImage.before,
              alt: currentImage.alt,
            }}
            secondImage={{
              imageUrl: currentImage.after,
              alt: currentImage.alt,
            }}
          />
        ) : (
          <img src={currentImage.src} alt={currentImage.alt} />
        )}

        <button className="modal-next" onClick={showNextImage}>
          &gt;
        </button>
      </div>

      {/* Render thumbnails only if there are any */}
      {thumbnails.length > 0 && (
        <div className="thumbnails">
          {thumbnails.map((thumb, index) => (
            <img
              key={index}
              className={`thumbnail ${thumb === currentImage.src ? "" : ""}`}
              src={thumb}
              alt={`${image.alt || "Thumbnail"} ${index + 1}`}
              onClick={() => handleThumbnailClick(thumb)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Modal;
